import React from "react";
import Button from "Components/common/Button";

const TagPopupButtons = props => {
  const { btnAction, backAction, nextBtnEnabled } = props;
  return (
    <div className="btnCont">
      <>
        <div
          className="continueBtn"
          id="closeBtn"
          onClick={e => {
            e.preventDefault();
            backAction && backAction();
          }}
        >
          Close
        </div>
        <Button
          id="nextBtn"
          name="nextBtn"
          type="submit"
          className={`nextBtn ${nextBtnEnabled ? "" : "disabled"}`}
          btnText="Add Contacts"
          icon={false}
          iconName=""
          click={e => {
            e.preventDefault();
            btnAction();
          }}
        ></Button>
      </>
    </div>
  );
};

export default TagPopupButtons;
export { TagPopupButtons };
